import React from 'react';

const ThePrepLogo = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 200 50"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    role="img"
    data-testid="thePrepLogo"
    style={{
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
    }}
  >
    <rect
      id="Artboard1"
      x="0"
      y="0"
      width="200"
      height="50"
      style={{ fill: 'none' }}
    />
    <g id="Artboard11">
      <g transform="matrix(0.384295,0,0,0.384295,40,8.08909)">
        <path
          d="M8.88,59.35L0,59.35L0,88.01L8.88,88.01L8.88,78.27L34.37,78.27L34.37,69.04L8.88,69.04L8.88,59.35Z"
          style={{ fill: 'rgb(127,48,116)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.384295,0,0,0.384295,40,8.08909)">
        <path
          d="M0,35.5L13.07,35.5L13.07,46.5L0,46.5L0,55.64L34.37,55.64L34.37,46.5L21.95,46.5L21.95,35.5L34.37,35.5L34.37,26.32L0,26.32L0,35.5Z"
          style={{ fill: 'rgb(127,48,116)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.384295,0,0,0.384295,40,8.08909)">
        <path
          d="M25.64,13.47L21.55,13.47L21.55,2.67L12.82,2.67L12.82,13.47L8.73,13.47L8.73,0L0,0L0,22.61L34.37,22.61L34.37,0L25.64,0L25.64,13.47Z"
          style={{ fill: 'rgb(127,48,116)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.384295,0,0,0.384295,40,8.08909)">
        <path
          d="M92.47,3.81C87.21,1.27 81.1,0 74.12,0L41.43,0L41.43,87.83L64.95,87.83L64.95,66.95L74.13,66.95C81.11,66.95 87.22,65.68 92.48,63.14C97.73,60.6 101.83,56.85 104.76,51.9C107.69,46.95 109.15,40.81 109.15,33.48C109.15,26.15 107.68,20.02 104.76,15.06C101.83,10.11 97.74,6.36 92.48,3.82L92.47,3.81ZM82.12,41.27C80.1,43.08 77.11,43.98 73.16,43.98L64.95,43.98L64.95,22.75L73.35,22.75C75.26,22.75 76.94,22.97 78.4,23.39C79.88,23.84 81.12,24.51 82.13,25.41C84.15,27.22 85.16,29.88 85.16,33.41C85.16,36.94 84.15,39.47 82.13,41.28L82.12,41.27Z"
          style={{ fill: 'rgb(127,48,116)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.384295,0,0,0.384295,40,8.08909)">
        <path
          d="M176.3,49.98C179.44,45.21 181.01,39.3 181.01,32.25C181.01,25.2 179.44,19.29 176.3,14.52C173.16,9.75 168.95,6.14 163.66,3.69C158.37,1.24 152.5,0.01 146.06,0.01L113.56,0.01L113.56,87.84L136.9,87.84L136.9,64.37L144.81,64.37L156.37,87.84L181.91,87.84L167.53,58.65C171.04,56.41 173.97,53.53 176.3,49.99L176.3,49.98ZM154.25,39.34C152.23,40.89 149.24,41.66 145.29,41.66L136.91,41.66L136.91,22.7L145.29,22.7C149.24,22.7 152.23,23.52 154.25,25.15C156.27,26.78 157.28,29.15 157.28,32.24C157.28,35.33 156.27,37.79 154.25,39.33L154.25,39.34Z"
          style={{ fill: 'rgb(127,48,116)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.384295,0,0,0.384295,40,8.08909)">
        <path
          d="M234.71,22.02C235.68,22.02 236.43,21.22 236.48,20.25L237.53,0L233.73,0L232.95,20.25C232.91,21.22 233.75,22.02 234.72,22.02L234.71,22.02Z"
          style={{ fill: 'rgb(127,48,116)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.384295,0,0,0.384295,40,8.08909)">
        <path
          d="M231.58,32.83L210.04,32.83L210.04,22.36L228.09,22.36C228.06,21.3 228.08,20.19 228.18,19.02L230.24,0L186.65,0L186.65,88.01L236.88,88.01L238.15,65.65L210.04,65.65L210.04,55.18L238.74,55.18L239.75,37.53C236.48,36.92 233.64,35.34 231.58,32.83Z"
          style={{ fill: 'rgb(127,48,116)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.384295,0,0,0.384295,40,8.08909)">
        <path
          d="M240.45,20.25C240.45,21.22 241.25,22.02 242.22,22.02C243.19,22.02 243.99,21.22 243.99,20.25L243.99,0L240.45,0L240.45,20.25Z"
          style={{ fill: 'rgb(127,48,116)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.384295,0,0,0.384295,40,8.08909)">
        <path
          d="M307.86,15.06C304.93,10.11 300.84,6.36 295.58,3.82C290.32,1.28 284.21,0.01 277.23,0.01L254.21,0.01L256.27,19.03C257.48,30.37 252.05,36.17 244.7,37.54L247.57,87.84L268.06,87.84L268.06,66.96L277.24,66.96C284.22,66.96 290.34,65.69 295.59,63.15C300.84,60.61 304.94,56.86 307.87,51.91C310.8,46.96 312.26,40.82 312.26,33.49C312.26,26.16 310.79,20.03 307.87,15.07L307.86,15.06ZM285.23,41.28C283.21,43.09 280.22,43.99 276.27,43.99L268.06,43.99L268.06,22.76L276.46,22.76C278.37,22.76 280.05,22.98 281.51,23.4C282.99,23.85 284.23,24.52 285.24,25.42C287.26,27.23 288.27,29.89 288.27,33.42C288.27,36.95 287.26,39.48 285.24,41.29L285.23,41.28Z"
          style={{ fill: 'rgb(127,48,116)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.384295,0,0,0.384295,40,8.08909)">
        <path
          d="M249.72,22.02C250.69,22.02 251.53,21.22 251.49,20.25L250.71,0L246.91,0L247.96,20.25C248.01,21.22 248.76,22.02 249.73,22.02L249.72,22.02Z"
          style={{ fill: 'rgb(127,48,116)', fillRule: 'nonzero' }}
        />
      </g>
    </g>
  </svg>
);

export default ThePrepLogo;
